module.exports = __webpack_public_path__ + "fonts/Knockout.be7ab7a7.woff";